import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import { useParams } from "react-router";
import { Redirect, useHistory } from "react-router-dom";
import useFlash from "go-alert/AlertMessage";
import Header from "go-app/components/Header";
import handleError from "go-app/services/errors";
import { useBrowserTabTitle } from "go-core/components/BrowserTab/useBrowserTabTitle";
import { LoadingContainer } from "go-core/components/Loading";
import { adminApi } from "../../../../../../../../services/Api/Admin/adminApi";
import { LoanApi } from "../../../../../../../../services/Api/types";
import { selectUser } from "../../../../../../../../services/users/selectors";
import LoanForm from "../../../../../../components/Loan/LoanForm";
import { FormatLoanStatuses } from "../../../../../Partner/pages/Preview/components/FormatLoanStatus";

interface MatchParams {
	id: string;
}

const AdminLoansEditPage = () => {
	const [loan, setLoan] = useState<undefined | LoanApi>(undefined);
	const user = useSelector(selectUser);
	const { addFlash } = useFlash();
	const { t } = useTranslation("admin");
	const history = useHistory();
	const { id } = useParams<MatchParams>();
	const { handleChangeTabTitle } = useBrowserTabTitle();

	useEffect(() => {
		fetchLoan();
	}, []);

	const fetchLoan = async () => {
		try {
			const res = await adminApi.getLoan(Number(id), { include: "organization,partner,items,attachments" });
			setLoan(res);
			handleChangeTabTitle(
				`#${res.reference_id} | ${t("modules.loan.header.title")} | ${t("lib:go_component.navigation.admin")}`
			);
		} catch (err) {
			handleError.alert(err, addFlash);
		}
	};

	if (!loan) return <LoadingContainer />;

	if (loan.status === "CLOSED") {
		return <Redirect to={`/admin/loans/${loan.id}`} />;
	}

	const goBack = () => {
		history.push(`/admin/loans/${loan.id}`);
	};

	const renderTitle = () => (
		<>
			{t("modules.loan.header.title")} #{loan.reference_id} {t("common.word.for")} "{loan.organization.name}
			"
			<FormatLoanStatuses loan={loan} />
		</>
	);

	return (
		<>
			<Header title={renderTitle()} back={goBack} />
			<LoanForm handleUpdate={setLoan} loan={loan} user={user} />
		</>
	);
};
export default AdminLoansEditPage;
